/*================================
  JS Information
----------------------------------
  File name: common.js
  Summary:   全ページ共通JSファイル
  Author:    neruco
================================*/

// const
const body = document.body;
const header = document.querySelector("header");
const footer = document.querySelector("footer");
const mainContents = document.querySelector(".l-main__contents");
const pageCode = body.className;

// 要素の幅・高さ取得
const windowWidth = window.innerWidth;
const scrollbarWidth = window.innerWidth - document.body.clientWidth;
const viewHeight = window.innerHeight;
const headerHeight = header.offsetHeight;
const footerHeight = footer.offsetHeight;

document.documentElement.style.setProperty("--js-scrollbarWidth", `${scrollbarWidth}px`);
document.documentElement.style.setProperty("--js-viewHeight", `${viewHeight}px`);
document.documentElement.style.setProperty("--js-headerHeight", `${headerHeight}px`);
document.documentElement.style.setProperty("--js-footerHeight", `${footerHeight}px`);
// document.documentElement.style.setProperty('--js-contentsHeight', `${contentsHeight}px`);

const scrollView = document.querySelectorAll('.js-scrollView');

window.addEventListener("scroll", function () {
  const scroll = window.scrollY;

  if (scroll > 0) {
    header.classList.add("is-fixed");

    scrollView.forEach((item) => {
      item.classList.add("is-fixed");
    });

  } else {
    header.classList.remove("is-fixed");

    scrollView.forEach((item) => {
      item.classList.remove("is-fixed");
    });
  }
});


// drawer
function drawer() {
  var drawerLinks = document.querySelectorAll(".l-drawer a");
  var drawerParts = document.querySelectorAll(".l-drawer, .c-drawerBtn");
  var drawerBtn = document.querySelector(".c-drawerBtn");
  // var drawerBtnTxt = document.querySelector(".c-drawerBtn__txt");

  for (let i = 0; i < drawerParts.length; i++) {
    // ハンバーガーメニューボタンクリック時の挙動
    drawerBtn.addEventListener("click", function () {
      const part = drawerParts[i];

      if (part.classList.contains("is-open")) {
        // 今開いてる → 閉じる処理
        part.classList.remove("is-open");

        // トランジション終了後に is-closed を付ける（CSSアニメ終了待ち）
        part.addEventListener("transitionend", function handleTransition() {
          part.classList.add("is-closed");
          part.removeEventListener("transitionend", handleTransition);
        });

        body.classList.remove("is-scrollNone");
        header.classList.remove("is-drawerOpen");
        drawerBtn.setAttribute("aria-expanded", "false");
      } else {
        // 今閉じてる → 開く処理
        part.classList.remove("is-closed");
        part.classList.add("is-open");

        body.classList.add("is-scrollNone");
        header.classList.add("is-drawerOpen");
        drawerBtn.setAttribute("aria-expanded", "true");
      }
    });

    // ドロワーメニュー内のリンクをクリック時にドロワーを閉じる
    for (let d = 0; d < drawerLinks.length; d++) {
      drawerLinks[d].addEventListener("click", function () {
        body.classList.remove("is-scrollNone");
        drawerParts[i].classList.remove("is-open");
        drawerParts[i].classList.add("is-closed");
        drawerBtn.setAttribute("aria-expanded", "false");
      });
    }
  }
}


// select
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.smf-select-control__control').forEach((select) => {
    select.classList.add('js-selectColor');
  });
});
document.querySelectorAll('.js-selectColor').forEach((select) => {
  const updateColor = () => {
    select.classList.toggle('is-selected', select.value !== '');
  };

  updateColor();
  select.addEventListener('change', updateColor);
});


// pageTopのスクロール先
function scrollToHead() {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
}
const pageTopBtn = document.querySelector('.js-pageTop');
if (pageTopBtn) {
  pageTopBtn.addEventListener('click', scrollToHead);
}


// アンカーリンククリックでscroll-margin-topが効くように補正スクロール
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    const targetId = this.getAttribute('href');
    const target = document.querySelector(targetId);

    if (target) {
      e.preventDefault();

      const headerHeight = header.offsetHeight || 0;
      const targetPosition = target.getBoundingClientRect().top + window.scrollY - headerHeight;

      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth',
      });
    }
  });
});


// アコーディオン
function accordion() {
  const mqPc = window.matchMedia("(min-width: 768px)");

  document.querySelectorAll(".js-accordion").forEach((wrap) => {
    const target = wrap.querySelector(".js-accordion__target");
    const trigger = wrap.querySelector(".js-accordion__trigger");
    if (!target || !trigger) return;

    target.addEventListener("transitionend", (e) => {
      if (e.propertyName !== "height") return;
      if (wrap.classList.contains("is-open")) {
        target.style.height = "auto";
      }
    });

    trigger.addEventListener("click", (e) => {

      // ✅ PC幅 & --hover & triggerがbuttonのときだけ無効
      if (
        wrap.classList.contains("--hover") &&
        mqPc.matches &&
        trigger.tagName.toLowerCase() === "button"
      ) {
        e.preventDefault();
        return;
      }

      const isOpen = wrap.classList.contains("is-open");

      if (isOpen) {
        target.style.height = target.getBoundingClientRect().height + "px";
        requestAnimationFrame(() => (target.style.height = "0px"));
        wrap.classList.remove("is-open");
        target.classList.remove("is-open");
        trigger.classList.remove("is-open");
      } else {
        target.style.height = "0px";
        wrap.classList.add("is-open");
        target.classList.add("is-open");
        trigger.classList.add("is-open");
        requestAnimationFrame(() => {
          target.style.height = target.scrollHeight + "px";
        });
      }
    });
  });
}

// Rank Math FAQ
document.querySelectorAll('.rank-math-list-item').forEach((el) => {
  el.classList.add('js-accordion');
});
document.querySelectorAll('.rank-math-question').forEach((el) => {
  el.classList.add('js-accordion__trigger');
});
document.querySelectorAll('.rank-math-answer').forEach((el) => {
  el.classList.add('js-accordion__target');
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.rank-math-question').forEach((question) => {
    if (!question.querySelector('.c-faqList__inner')) {
      question.innerHTML = `<div class="c-faqList__inner">${question.innerHTML}</div>`;
    }

    question.classList.add('js-accordion__trigger');
  });

  document.querySelectorAll('.rank-math-answer').forEach((answer) => {
    if (!answer.querySelector('.c-faqList__inner')) {
      answer.innerHTML = `<div class="c-faqList__inner">${answer.innerHTML}</div>`;
    }

    answer.classList.add('js-accordion__target');
  });

  document.querySelectorAll('.rank-math-list-item').forEach((item) => {
    item.classList.add('js-accordion');
  });
});

// アコーディオン（hover）
function accordionHover() {
  var accordions = document.querySelectorAll(".js-accordion.--hover");
  var windowWidth = window.innerWidth; // 現在のウィンドウ幅を取得

  // Hoverで動作するアコーディオン（PC向け）
  if (windowWidth >= 768) {
    accordions.forEach(function (accordion) {
      var accordionTarget = accordion.querySelector(".js-accordion__target");
      var accordionTrigger = accordion.querySelector(".js-accordion__trigger");

      // マウスが要素上に入ったとき
      accordion.addEventListener("mouseenter", function () {
        accordion.classList.add("is-open");
        accordionTarget.classList.add("is-open");
        accordionTrigger.classList.add("is-open");
      });

      // マウスが要素から離れたとき
      accordion.addEventListener("mouseleave", function () {
        accordion.classList.remove("is-open");
        accordionTarget.classList.remove("is-open");
        accordionTrigger.classList.remove("is-open");
      });
    });
  }
}



/*==アニメーション==================*/

// ロードしたらアニメーション
var loadAnimeTargets = document.querySelectorAll(".js-loadAnime");
// var loading = document.querySelector('.p-loading');
window.addEventListener("load", function () {
  for (let target of loadAnimeTargets) {
    setTimeout(() => {
      target.classList.add("is-animated");
    }, 800);
  }
  setTimeout(() => {
    // loading
    body.classList.add("is-loaded");
    // loading.classList.add('is-loaded');
  }, 0);
});

// 画面に表示されたらアニメーション
var scrollAnimeTargets = document.querySelectorAll(
  ".js-scrollAnime-fadeIn, .js-scrollAnime-fadeInUp, .js-scrollAnime-fadeInLeftRight, .js-scrollAnime-fadeInRightLeft, .js-scrollAnime-band, .js-scrollAnime-line"
);
window.addEventListener("scroll", function () {
  var scroll = window.scrollY;
  for (let target of scrollAnimeTargets) {
    var targetPos = target.getBoundingClientRect().top + scroll + 100;
    if (scroll > targetPos - viewHeight) {
      target.classList.add("is-animated");
    }
  }
});


// detailsをJSでアニメーション
const details = document.querySelectorAll("details");

details.forEach((detail) => {
  const summary = detail.querySelector("summary");

  summary.addEventListener("click", (e) => {
    e.preventDefault();

    const isOpen = detail.open;

    if (isOpen) {
      const height = detail.offsetHeight;

      detail.style.height = height + "px";

      requestAnimationFrame(() => {
        detail.style.height = summary.offsetHeight + "px";
      });

      detail.addEventListener(
        "transitionend",
        () => {
          detail.open = false;
          detail.style.height = "";
        },
        { once: true }
      );
    } else {
      detail.open = true;

      const height = detail.offsetHeight;

      detail.style.height = summary.offsetHeight + "px";

      requestAnimationFrame(() => {
        detail.style.height = height + "px";
      });

      detail.addEventListener(
        "transitionend",
        () => {
          detail.style.height = "";
        },
        { once: true }
      );
    }
  });
});


// グロナビ カレント表示
function navCurrent() {
  const navLinks = document.querySelectorAll('.l-nav .menu-item a[href*="#"]');

  if (!navLinks.length) return;

  const sections = [...navLinks]
    .map((link) => {
      const href = link.getAttribute('href');
      const hash = href.includes('#') ? `#${href.split('#')[1]}` : '';
      const section = hash ? document.querySelector(hash) : null;

      return section ? { hash, section } : null;
    })
    .filter(Boolean);

  if (!sections.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        const currentHash = `#${entry.target.id}`;

        navLinks.forEach((link) => {
          const href = link.getAttribute('href');
          const hash = href.includes('#') ? `#${href.split('#')[1]}` : '';

          link.classList.toggle('is-current', hash === currentHash);
        });
      });
    },
    {
      rootMargin: '-40% 0px -55% 0px',
      threshold: 0,
    }
  );

  sections.forEach(({ section }) => {
    observer.observe(section);
  });
}


/*==ON/OFF========================*/

VanillaMatchHeight.applyDataApi();
drawer();
accordion();
accordionHover();
navCurrent();

/*================================*/
